import { useMutation } from '@tanstack/react-query';
import { apiClinicOnboardingRegisterUser } from 'lib/api/firebase/apis/apis';


export function useUserRegistrationMutation() {
  return useMutation({
    mutationFn: apiClinicOnboardingRegisterUser,
  });
}
